import { Injectable, inject } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import {
  Observable,
  catchError,
  from,
  map,
  of,
  switchMap,
  take,
  timeout,
} from "rxjs";

import { AppInitService } from "src/app/shared/services/app-init.service";
import { ExperimentService } from "src/app/shared/services/experiment.service";

/**
 * Typed access to the ID-card image rollout feature.
 *
 * Route decisions fail closed. They never request a GrowthBook refresh.
 */
@Injectable({ providedIn: "root" })
export class IdCardImageRolloutExperimentKeyService {
  private static readonly KEY =
    "BHARGAVM-Reduce-ID-Card-Image-Memory-FE-2695" as const;
  private static readonly ROUTE_TIMEOUT_MS = 1000;

  private readonly appInitService = inject(AppInitService);
  private readonly experimentService = inject(ExperimentService);

  isOnWhenReadyForUser$(
    userId: string,
    timeoutMs = IdCardImageRolloutExperimentKeyService.ROUTE_TIMEOUT_MS
  ): Observable<boolean> {
    return this.appInitService
      .onAuthenticatedExperimentsReadyForUser$(userId)
      .pipe(
        take(1),
        switchMap(() =>
          from(
            this.experimentService.addLocalEvaluationAttributes({
              appPlatform: Capacitor.getPlatform(),
            })
          )
        ),
        map(() => {
          this.experimentService.invalidateEvaluation(
            IdCardImageRolloutExperimentKeyService.KEY
          );
          return this.experimentService.isOn(
            IdCardImageRolloutExperimentKeyService.KEY,
            false
          );
        }),
        timeout({
          first: timeoutMs,
          with: () => of(false),
        }),
        catchError(() => of(false))
      );
  }
}
